function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(3 3)"
},
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M4.2764,10.0386 C3.8454,10.0386 3.4134,10.2036 3.0854,10.5326 C2.4264,11.1906 2.4264,12.2576 3.0854,12.9146 C3.4134,13.2446 3.8454,13.4086 4.2764,13.4086 C4.7074,13.4086 5.1384,13.2446 5.4674,12.9146 C6.1264,12.2576 6.1264,11.1906 5.4674,10.5326 C5.1384,10.2036 4.7074,10.0386 4.2764,10.0386"
}),
/*#__PURE__*/
React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M6.2642,6.1611 C4.5902,5.7071 2.7442,6.1071 1.4432,7.4081 C-0.5018,9.3521 -0.4778,12.5301 1.4962,14.5041 C3.4702,16.4781 6.6472,16.5011 8.5922,14.5571 C9.8922,13.2561 10.2932,11.4101 9.8392,9.7361 L10.7192,8.8551 L10.7062,7.0811 L12.4792,7.0951 L13.3602,6.2141 L13.3472,4.4401 L15.1212,4.4531 L15.8202,3.7541 C15.9362,3.6381 16.0012,3.4791 16.0002114,3.3131 L15.9802,0.6491 C15.9772,0.3041 15.6962,0.0221 15.3502,0.0191 L12.6862,8.84560706e-05 C12.5202,-0.0009 12.3622,0.0631 12.2462,0.1801 L6.2642,6.1611"
}));

var SvgAccessTokens = function SvgAccessTokens(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22,
      height: 22,
      viewBox: "0 0 22 22"
    }, props), _ref)
  );
};

export default SvgAccessTokens;